import { canViewMyPortfolioToggle } from "./my-relationships/relationshipTabAccess";

type LoggedInUserRef = {
  user_id?: string;
  userId?: string;
  id?: string;
  role?: string | null;
} | null;

export function resolveLoggedInUserId(loggedInUser?: LoggedInUserRef): string {
  return String(
    loggedInUser?.user_id || loggedInUser?.userId || loggedInUser?.id || ""
  ).trim();
}

function normalizeStakeholderUserIds(ids: string[] = []): string[] {
  const normalized = ids
    .map(id => String(id).trim())
    .filter(Boolean)
    .filter((id, index, array) => array.indexOf(id) === index);
  return normalized.sort();
}

function areStakeholderSelectionsEqual(a: string[], b: string[]): boolean {
  const left = normalizeStakeholderUserIds(a);
  const right = normalizeStakeholderUserIds(b);
  if (left.length !== right.length) return false;
  return left.every((id, index) => id === right[index]);
}

export function resolveMyPortfolioUserIds(
  loggedInUser?: LoggedInUserRef
): string[] {
  const userId = resolveLoggedInUserId(loggedInUser);
  return userId ? [userId] : [];
}

function canUseMyPortfolioForRole(role?: string | null): boolean {
  return canViewMyPortfolioToggle(role);
}

/** True when this role may use My Portfolio and sponsor selection differs from own. */
export function canShowMyPortfolioToggle(
  selectedIds: string[],
  loggedInUser?: LoggedInUserRef
): boolean {
  if (!canUseMyPortfolioForRole(loggedInUser?.role)) return false;

  const myPortfolioUserIds = resolveMyPortfolioUserIds(loggedInUser);
  if (!myPortfolioUserIds.length) return false;

  const selected = normalizeStakeholderUserIds(selectedIds);
  if (!selected.length) return false;

  return !areStakeholderSelectionsEqual(selected, myPortfolioUserIds);
}

export function resolveEffectiveAccountUserIds(
  selectedIds: string[],
  viewMyPortfolio: boolean,
  loggedInUser?: LoggedInUserRef
): string[] {
  if (viewMyPortfolio && canUseMyPortfolioForRole(loggedInUser?.role)) {
    return resolveMyPortfolioUserIds(loggedInUser);
  }
  return selectedIds;
}
